import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { createMRTColumnHelper } from "material-react-table";
import Chip from "@mui/material/Chip";
import CustomTable from "../../../../components/custom_table/CustomTable";
import { baseUrl } from "../../../../helper/urls";
import { Icon } from "@iconify/react";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import { useSelector } from "react-redux";

const RescheduledBookingList = () => {
  const { token } = useSelector((state) => state.auth);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const RescheduledBookings = async () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(
        `${baseUrl}/api/reschedule/counselor/list`,
        { headers }
      );

      const data = response.data.data || [];

      // Add formattedReqId here
      const processedData = data.map((item) => ({
        ...item,
        formattedReqId: `DDR000${item.reqId || ""}`,
        studentName: `${item.s_firstName || ""} ${item.s_lastName || ""
          }`.trim(),
        serviceType: item.type || "",
      }));

      setBookings(processedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setError("Failed to fetch bookings");
      setLoading(false);
    }
  };

  useEffect(() => {
    RescheduledBookings();
  }, []);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("studentName", {
      header: "Student Name",
    }),
    // columnHelper.accessor("request_by", {
    //   header: "Requested By",
    //   size: 30,
    //   Cell: (cell) => cell.row.original.request_by,
    // }),
    // columnHelper.accessor("approved_by", {
    //   header: "Approved By",
    //   size: 30,
    //   Cell: (cell) => cell.row.original.approved_by,
    // }),
    columnHelper.accessor("serviceType", {
      header: "Service Type",
      size: 30,
    }),
    columnHelper.accessor("reason", {
      header: "Reason",
      size: 30,
      Cell: (cell) => cell.row.original.reason,
    }),
    columnHelper.accessor("date", {
      header: "Slot Date (UTC)",
      size: 30,
      // Cell: (cell) => cell.row.original.date,
      Cell: (cell) => cell.row.original.utcTime?.split("T")[0] || "N/A",

    }),
    // columnHelper.accessor("booking_date", {
    //   header: "Slot Date",
    //   Cell: (cell) => {
    //     const date = cell.row.original?.booking_date;
    //     return date ? new Date(date).toLocaleDateString("en-IN") : "N/A";
    //   },
    // }),

    // columnHelper.accessor("created_at", {
    //   header: "Slot Date",
    //   size: 30,
    //   Cell: (cell) => {
    //     const rawDate = cell.row.original?.created_at;
    //     if (!rawDate) return "N/A";

    //     const dateObj = new Date(rawDate);
    //     const day = String(dateObj.getDate()).padStart(2, "0");
    //     const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    //     const year = dateObj.getFullYear();

    //     return `${day}-${month}-${year}`;
    //   },
    // }),
    columnHelper.accessor("formattedReqId", {
      header: "Request ID",
    }),
  ];

  columns.unshift(
    columnHelper.accessor("actions", {
      header: "Actions",
      Cell: ({ cell }) => {
        const id = cell.row.original.id;
        const status = cell.row.original.status;

        const handleApprove = () => {
          Swal.fire({
            html: `<div style="font-size: 30px; font-weight: bold;">Are you sure?</div>`,
            text: "Do you want to approve this reschedule request?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, Approve",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          }).then((result) => {
            if (result.isConfirmed) {
              axios
                .get(`${baseUrl}/api/reschedule/counselor/approved/${id}`, {
                  headers: {
                    Authorization: `Bearer ${token}`, // assume token from session
                  },
                })
                .then((res) => {
                  Swal.fire(
                    "Approved!",
                    "Reschedule has been approved.",
                    "success"
                  );
                  RescheduledBookings(); // reload updated data
                })
                .catch((err) => {
                  Swal.fire(
                    "Error!",
                    err.response?.data?.message || "Failed to approve request.",
                    "error"
                  );
                });
            }
          });
        };

        return (
          <Box display="flex" alignItems="center" gap={1}>
            {status == 0 ? (
              <Button
                variant="contained"
                size="small"
                color="error"
                onClick={handleApprove}
                sx={{ textTransform: "none" }}
              >
                Agree
              </Button>
            ) : (
              <span style={{ color: "green" }}>Approved</span>
            )}
          </Box>
        );
      },
    })
  );

  return (
    <MasterLayout>
      <CustomTable columns={columns} data={bookings} loading={loading} />
    </MasterLayout>
  );
};

export default RescheduledBookingList;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { createMRTColumnHelper } from "material-react-table";
// import Chip from "@mui/material/Chip";
// import CustomTable from "../../../../components/custom_table/CustomTable";
// import { baseUrl } from "../../../../helper/urls";
// import { Icon } from "@iconify/react";
// import { Box, Button, IconButton, Tooltip } from "@mui/material";
// import EventRepeatIcon from "@mui/icons-material/EventRepeat";
// import MasterLayout from "../../../../masterLayout/MasterLayout";
// import { useSelector } from "react-redux";

// const RescheduledBookingList = () => {
//   const { token } = useSelector((state) => state.auth);
//   const [bookings, setBookings] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const RescheduledBookings = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     };

//     try {
//       const response = await axios.get(
//         `${baseUrl}/api/reschedule/counselor/list`,
//         { headers }
//       );
//       setBookings(response.data.data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching bookings:", error);
//       setError("Failed to fetch bookings");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     RescheduledBookings();
//   }, []);

//   const columnHelper = createMRTColumnHelper();
//   const columns = [
//     columnHelper.accessor("firstName", {
//       header: "Student Name",
//       Cell: (cell) =>
//         `${cell.row.original.s_firstName || ""} ${
//           cell.row.original.s_lastName || ""
//         }`,
//     }),
//     // columnHelper.accessor("request_by", {
//     //   header: "Requested By",
//     //   size: 30,
//     //   Cell: (cell) => cell.row.original.request_by,
//     // }),
//     // columnHelper.accessor("approved_by", {
//     //   header: "Approved By",
//     //   size: 30,
//     //   Cell: (cell) => cell.row.original.approved_by,
//     // }),
//     columnHelper.accessor("type", {
//       header: "Service Type",
//       size: 30,
//       Cell: (cell) => cell.row.original.type,
//     }),
//     columnHelper.accessor("reason", {
//       header: "Reason",
//       size: 30,
//       Cell: (cell) => cell.row.original.reason,
//     }),
//     columnHelper.accessor("date", {
//       header: "Slot Date",
//       size: 30,
//       Cell: (cell) => cell.row.original.date,
//     }),
//     // columnHelper.accessor("booking_date", {
//     //   header: "Slot Date",
//     //   Cell: (cell) => {
//     //     const date = cell.row.original?.booking_date;
//     //     return date ? new Date(date).toLocaleDateString("en-IN") : "N/A";
//     //   },
//     // }),

//     // columnHelper.accessor("created_at", {
//     //   header: "Slot Date",
//     //   size: 30,
//     //   Cell: (cell) => {
//     //     const rawDate = cell.row.original?.created_at;
//     //     if (!rawDate) return "N/A";

//     //     const dateObj = new Date(rawDate);
//     //     const day = String(dateObj.getDate()).padStart(2, "0");
//     //     const month = String(dateObj.getMonth() + 1).padStart(2, "0");
//     //     const year = dateObj.getFullYear();

//     //     return `${day}-${month}-${year}`;
//     //   },
//     // }),
//     columnHelper.accessor("reqId", {
//       header: "Request ID",
//       Cell: (cell) => "DDR000" + cell.row.original?.reqId || "-",
//     }),
//   ];

//   columns.unshift(
//     columnHelper.accessor("actions", {
//       header: "Actions",
//       Cell: ({ cell }) => {
//         const id = cell.row.original.id;
//         const status = cell.row.original.status;

//         const handleApprove = () => {
//           Swal.fire({
//             html: `<div style="font-size: 30px; font-weight: bold;">Are you sure?</div>`,
//             text: "Do you want to approve this reschedule request?",
//             icon: "question",
//             showCancelButton: true,
//             confirmButtonText: "Yes, Approve",
//             cancelButtonText: "Cancel",
//             confirmButtonColor: "#3085d6",
//             cancelButtonColor: "#d33",
//           }).then((result) => {
//             if (result.isConfirmed) {
//               axios
//                 .get(`${baseUrl}/api/reschedule/counselor/approved/${id}`, {
//                   headers: {
//                     Authorization: `Bearer ${token}`, // assume token from session
//                   },
//                 })
//                 .then((res) => {
//                   Swal.fire(
//                     "Approved!",
//                     "Reschedule has been approved.",
//                     "success"
//                   );
//                   RescheduledBookings(); // reload updated data
//                 })
//                 .catch((err) => {
//                   Swal.fire(
//                     "Error!",
//                     err.response?.data?.message || "Failed to approve request.",
//                     "error"
//                   );
//                 });
//             }
//           });
//         };

//         return (
//           <Box display="flex" alignItems="center" gap={1}>
//             {status == 0 ? (
//               <Button
//                 variant="contained"
//                 size="small"
//                 color="error"
//                 onClick={handleApprove}
//                 sx={{ textTransform: "none" }}
//               >
//                 Agree
//               </Button>
//             ) : (
//               <span style={{ color: "green" }}>Approved</span>
//             )}
//           </Box>
//         );
//       },
//     })
//   );

//   return (
//     <MasterLayout>
//       <CustomTable columns={columns} data={bookings} loading={loading} />
//     </MasterLayout>
//   );
// };

// export default RescheduledBookingList;
